import backgroundImg from './background.png';
import buttonYesImg from './button_yes.png';
import buttonNoImg from './button_no.png';
import ticketImg from '../../components/atomic/icons/ticket/ticket.png';
import './AgainScreen.css';

export type AgainScreenProps = {
  onYes?: () => void;
  onNo?: () => void;
};

/** Replay confirmation window over the delivery list. */
export function AgainScreen({ onYes, onNo }: AgainScreenProps) {
  return (
    <div className="again-screen" role="dialog" aria-modal="true" aria-label="Пройти уровень заново?">
      <button
        type="button"
        className="again-screen__backdrop"
        aria-label="Закрыть"
        onClick={onNo}
      />
      <div className="again-screen__plaque">
        <img
          className="again-screen__background"
          src={backgroundImg}
          alt=""
          draggable={false}
        />
        <p className="again-screen__prompt">
          <span className="again-screen__prompt-line">
            Потратить 1
            <img
              className="again-screen__ticket"
              src={ticketImg}
              alt=""
              draggable={false}
            />
          </span>
          <span className="again-screen__prompt-line">
            чтобы пройти уровень заново?
          </span>
        </p>
        <button
          type="button"
          className="again-screen__button again-screen__button--yes"
          aria-label="Да"
          onClick={onYes}
        >
          <img src={buttonYesImg} alt="" draggable={false} />
        </button>
        <button
          type="button"
          className="again-screen__button again-screen__button--no"
          aria-label="Нет"
          onClick={onNo}
        >
          <img src={buttonNoImg} alt="" draggable={false} />
        </button>
      </div>
    </div>
  );
}
